module.exports = __webpack_public_path__ + "img/localbanner.578e63fe.png";